export default __webpack_public_path__ + "static/media/Boye (3).2ba113a4.jpg";